const AQUA_LION_RUN_FLAG = 'pkk:aqua-lion-run';

export const markAquaLionRunOnLogin = () => {
  try {
    sessionStorage.setItem(AQUA_LION_RUN_FLAG, '1');
  } catch {
    // Ignore storage failures in restrictive browser contexts.
  }
};

export const consumeAquaLionRunFlag = () => {
  try {
    const shouldRun = sessionStorage.getItem(AQUA_LION_RUN_FLAG) === '1';
    if (shouldRun) {
      sessionStorage.removeItem(AQUA_LION_RUN_FLAG);
    }
    return shouldRun;
  } catch {
    return false;
  }
};
